// import { validateJWT } from '../utils/validateJWT';

export const UserGuard = (): boolean => {
	const token = localStorage.getItem('accessToken'); // readFromStorage('accessToken');
	// const isValid = validateJWT(token);
	return !!token;
};
